import { useAtom } from 'jotai';
import { preferencesAtom } from '../Jotai/Atoms/tempPrefsAtom'; // Assuming this atom holds the structure

// Define the expected shape of preferences for clarity (adjust if needed based on atom definition)
// interface Preferences {
//     contrast: boolean;
//     showSettingsPanel: boolean;
//     arrangements: boolean;
//     startZoomFactor: number;
//     zoom: number;
//     detailZoom: number;
//     clockZoom: number;
//     startClockZoom: number;
//     titleZoom: number;
//     subheaderZoom: number;
//     timeZoom: number; // For countdown
//     chipZoom: number;
//     reminderZoom: number;
//     notesZoom: number;
//     supervisionZoom: number;
//     showNotes: boolean;
//     showSupervision: boolean;
//     viewMode: 'columns' | 'rows' | 'grid';
//     numColumns: number;
//     themeMode: 'light' | 'dark';
//     // ---- New fields ----
//     showStartTime: boolean;
//     showCurrentTime: boolean;
//     showCountdown: boolean;
//     showEndTime: boolean;
//     showSeconds: boolean; // For current time clock
// }


export const usePreferences = () => {
    const [preferences, setPreferences] = useAtom(preferencesAtom);

    // --- Existing Handlers ---
    const handleToggleContrast = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            contrast: !prevPreferences.contrast,
        }));
    };

    const setContrastToFalse = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            contrast: false,
        }));
    };

    const handleSetShowSettingsPanel = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showSettingsPanel: !prevPreferences.showSettingsPanel,
        }));
    };

    const setShowSettingsPanelToFalse = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showSettingsPanel: false,
        }));
    };

    const handleSetShowArrangements = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            arrangements: !prevPreferences.arrangements,
        }));
    };

    const setShowArrangementsToFalse = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            arrangements: false,
        }));
    };

    const handleSetStartZoomFactor = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            startZoomFactor: value,
        }));
    };

    const handleZoomChange = (value) => {
        setPreferences((prevPreferences) => {
            let newZoom = prevPreferences.zoom + value;
            if (newZoom < 0) newZoom = 0;
            if (newZoom > 100) newZoom = 100; // Or a more reasonable max like 10?

            return {
                ...prevPreferences,
                zoom: newZoom,
            };
        });
    };

    const setZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            zoom: 1,
        }));
    };

    const handleDetailZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            detailZoom: (prevPreferences.detailZoom || 1) + value, // Add default value check
        }));
    };

    const setDetailZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            detailZoom: 1,
        }));
    };

    const handleClockZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            clockZoom: (prevPreferences.clockZoom || 1) + value, // Add default value check
        }));
    };

    const setClockZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            clockZoom: 1,
        }));
    };

    const handleStartClockZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            startClockZoom: (prevPreferences.startClockZoom || 1) + value, // Add default value check
        }));
    };

    const setStartClockZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            startClockZoom: 1,
        }));
    };

    const handleTitleZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            titleZoom: (prevPreferences.titleZoom || 1) + value, // Add default value check
        }));
    };

    const setTitleZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            titleZoom: 1,
        }));
    };

    const handleSubheaderZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            subheaderZoom: (prevPreferences.subheaderZoom || 0.8) + value, // Add default value check
        }));
    };

    const setSubheaderZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            subheaderZoom: 0.8,
        }));
    };

    const handleTimeZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            timeZoom: (prevPreferences.timeZoom || 1) + value, // Add default value check
        }));
    };

    const setTimeZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            timeZoom: 1,
        }));
    };

    const handleChipZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            chipZoom: (prevPreferences.chipZoom || 0.5) + value, // Add default value check
        }));
    };

    const setChipZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            chipZoom: 0.5,
        }));
    };

    const handleReminderZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            reminderZoom: (prevPreferences.reminderZoom || 1) + value, // Add default value check
        }));
    };

    const setReminderZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            reminderZoom: 1,
        }));
    };

    const handleNotesZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            notesZoom: (prevPreferences.notesZoom || 1) + value, // Add default value check
        }));
    };

    const setNotesZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            notesZoom: 1,
        }));
    };

    const handleSupervisionZoomChange = (value) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            supervisionZoom: (prevPreferences.supervisionZoom || 1) + value, // Add default value check
        }));
    };

    const setSupervisionZoomToOne = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            supervisionZoom: 1,
        }));
    };

    const handleSetShowNotes = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showNotes: !prevPreferences.showNotes,
        }));
    };

    const handleSetShowSupervision = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showSupervision: !prevPreferences.showSupervision,
        }));
    };

    // --- New Handlers ---
    const handleSetShowStartTime = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showStartTime: !prevPreferences.showStartTime,
        }));
    };

    const handleSetShowCurrentTime = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showCurrentTime: !prevPreferences.showCurrentTime,
        }));
    };

    const handleSetShowCountdown = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showCountdown: !prevPreferences.showCountdown,
        }));
    };

    const handleSetShowEndTime = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showEndTime: !prevPreferences.showEndTime,
        }));
    };

    const handleSetShowSeconds = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showSeconds: !prevPreferences.showSeconds,
        }));
    };

    // --- Handlers for options from InvigilationOptions.js ---
    const handleSetUse24HourTime = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            use24HourTime: !prevPreferences.use24HourTime,
        }));
    };

    const handleSetShowQualification = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showQualification: !prevPreferences.showQualification,
        }));
    };

    const handleSetShowLevel = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showLevel: !prevPreferences.showLevel,
        }));
    };

    const handleSetShowFiveMins = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showFiveMins: !prevPreferences.showFiveMins,
        }));
    };

    const handleSetShowThirtyMins = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showThirtyMins: !prevPreferences.showThirtyMins,
        }));
    };

    const handleSetUseSound = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            useSound: !prevPreferences.useSound,
        }));
    };

    const handleSetShowEndings = () => { // Renamed from showEndTime
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showEndings: !prevPreferences.showEndings,
        }));
    };

    const handleSetShowDividers = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showDividers: !prevPreferences.showDividers,
        }));
    };

    const handleSetShowGranularZoomControls = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showGranularZoomControls: !prevPreferences.showGranularZoomControls,
        }));
    };

    const handleSetShowPauseControls = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showPauseControls: !prevPreferences.showPauseControls,
        }));
    };

    const handleSetShowExtraTimeControls = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showExtraTimeControls: !prevPreferences.showExtraTimeControls,
        }));
    };

    // --- Handlers for Paper/Duration ---
    const handleSetShowPaper = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showPaper: !prevPreferences.showPaper,
        }));
    };

    const handleSetShowDuration = () => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            showDuration: !prevPreferences.showDuration,
        }));
    };

    // Add more preference-related functions as needed

    return {
        preferences,
        // Existing setters
        handleToggleContrast,
        setContrastToFalse,
        handleSetShowSettingsPanel,
        setShowSettingsPanelToFalse,
        handleSetStartZoomFactor,
        handleZoomChange,
        setZoomToOne,
        handleDetailZoomChange,
        setDetailZoomToOne,
        handleTitleZoomChange,
        setTitleZoomToOne,
        handleSubheaderZoomChange,
        setSubheaderZoomToOne,
        handleTimeZoomChange,
        setTimeZoomToOne,
        handleChipZoomChange,
        setChipZoomToOne,
        handleReminderZoomChange,
        setReminderZoomToOne,
        handleSetShowArrangements,
        setShowArrangementsToFalse,
        handleClockZoomChange,
        setClockZoomToOne,
        handleStartClockZoomChange,
        setStartClockZoomToOne,
        handleNotesZoomChange,
        setNotesZoomToOne,
        handleSupervisionZoomChange,
        setSupervisionZoomToOne,
        handleSetShowNotes,
        // handleSetShowNotes, // Duplicate removed
        handleSetShowSupervision,
        // New setters
        handleSetShowStartTime,
        handleSetShowCurrentTime,
        handleSetShowCountdown,
        handleSetShowEndings, // Renamed
        handleSetShowSeconds,
        // Added handlers
        handleSetUse24HourTime,
        handleSetShowQualification,
        handleSetShowLevel,
        handleSetShowFiveMins,
        handleSetShowThirtyMins,
        handleSetUseSound,
        handleSetShowDividers,
        handleSetShowGranularZoomControls,
        handleSetShowPauseControls,
        handleSetShowExtraTimeControls,
        // Added Paper/Duration handlers
        handleSetShowPaper,
        handleSetShowDuration,
        // Return more functions as needed
    };
};
